import React from "react";
import { Badge } from "@chakra-ui/react";
import { useIntl } from "react-intl";

interface SharedStatusBadgeProps {
  status: 'NO_NEED' | 'NEEDS_APPROVAL' | 'APPROVED' | 'REJECTED';
}

const SharedStatusBadge: React.FC<SharedStatusBadgeProps> = ({ status }) => {
  const { formatMessage } = useIntl();
  // Don't render anything for NO_NEED status
  if (status === 'NO_NEED') {
    return null;
  }

  // Define badge properties based on status
  let label: string;
  let colorScheme: "orange" | "green" | "red";

  switch (status) {
    case 'NEEDS_APPROVAL':
      label = formatMessage({ id: "intentionNeedsApproval" });
      colorScheme = 'orange';
      break;
    case 'APPROVED':
      label = formatMessage({ id: "intentionApproved" });
      colorScheme = 'green';
      break;
    case 'REJECTED':
      label = formatMessage({ id: "intentionRejected" });
      colorScheme = 'red';
      break;
    default:
      return null;
  }

  return (
    // @ts-ignore
    <Badge
      colorScheme={colorScheme}
      variant="solid"
      fontSize="xs"
      px={2}
      py={1}
      borderRadius="full"
      textTransform="capitalize"
    >
      {label}
    </Badge>
  );
};

export default SharedStatusBadge; 